<input (ngModelChange)='inputChanged($event)' [ngModel]='displayedCode' pInputText placeholder='Second Life Id' type='text'>
